import { useEffect, useState } from "react";
import api from "@/utils/connector/ApiConnector";
import { useUser } from "@/utils/userContext/UserContext";

export function useCustomerSubscriptions(customerId: string | undefined) {
  const [loading, setLoading] = useState(false);
  const [subscriptions, setSubscriptions] = useState<any>(null);
  const [error, setError] = useState<string | null>(null);
  const { userData } = useUser();
  const token = userData?.auth;

  useEffect(() => {
    if (!customerId || !token) return;
    setLoading(true);
    setSubscriptions(null);
    setError(null);
    api.get(`/subscriptions/customer/${customerId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then(resp => {
        const data = (resp && typeof resp === 'object' && 'data' in resp) ? (resp as any).data : resp;
        setSubscriptions(data);
      })
      .catch(() => setError("Erro ao carregar informações adicionais."))
      .finally(() => setLoading(false));
  }, [customerId, token]);

  return { loading, subscriptions, error };
}
